import { styled } from '@mui/material/styles'
import { Box, TableContainer } from '@mui/material'

export const TableWrapper = styled(Box)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
})

export const TableContainerStyled = styled(TableContainer)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  overflow: 'hidden',
  boxShadow: 'none',
  minHeight: 0,
})

export const VirtualTableContainer = styled(Box)({
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  display: 'block',
  // height: '520px', // or any fixed height you want
  width: '100%',
  overflowY: 'scroll',
  position: 'relative',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
})

export const VirtualRow = styled(Box)({
  position: 'absolute',
  left: 0,
  height: `52px`,
  willChange: 'transform',
  display: 'flex',
  width: '100%',
  padding: '16px',
  '&:nth-of-type(even)': {
    backgroundColor: '#F7F8FA',
  },
  // '&:hover': {
  backgroundColor: '#f5f5f5',
  // },
})

export const VirtualCell = styled(Box)(({ theme }) => ({
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  wordBreak: 'break-word',
  textAlign: 'center',
  fontSize: '12px',
  flex: 1,
  flexBasis: 'auto',
  [theme.breakpoints.down('sm')]: {
    fontSize: '10px',
  },
}))

// export const VirtualTableContainer = styled(Box)({
//   transform: 'translateZ(0)',
//   backfaceVisibility: 'hidden',
//   // height: `calc(100% - 120px)`,
//   display: "block",
//   height: "520px",
//   width: "100%",

//   // flex: 1,
//   overflowY: 'scroll',
//   position: 'relative',
//   scrollbarWidth: 'thin',
//   scrollbarColor: '#888 #f1f1f1',
//   '&::-webkit-scrollbar': {
//     width: '8px',
//     height: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     backgroundColor: '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     backgroundColor: '#888',
//     borderRadius: '4px',
//     '&:hover': {
//       backgroundColor: '#555',
//     },
//   },
// })

// export const VirtualRow = styled(Box)({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   height: '10%',
//   willChange: 'transform',
//   display: 'flex',
//   width: '100%',
//   padding: '16px',
//   '&:nth-of-type(even)': {
//     backgroundColor: '#F7F8FA',
//   },
//   '&:hover': {
//     backgroundColor: '#f5f5f5',
//   },
// })

// export const VirtualCell = styled(Box)(({ theme }) => ({
//   padding: '8px 16px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   wordBreak: 'break-word',
//   textAlign: "center",
//   fontSize: '12px',
//   flex: 'none',
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '10px',
//   },
// }))

// export const VirtualCell = styled(Box)(({ theme }) => ({
//   padding: '8px 16px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   fontSize: '12px',
//   flex: 'none',
//   textAlign: 'center',
//   wordBreak: 'break-word', // breaks long words
//   overflow: 'hidden',
//   whiteSpace: 'normal', // allow text to wrap
//   [theme.breakpoints.down('sm')]: {
//     fontSize: '10px',
//   },
// }));
